import { reduce } from "et3-type-guards";
import getReportsStore from ".";
import getCoreUIStore from "../core/core-ui-store";
import { parseConversationData } from "../../helpers/et3-conversation-parse";
import getCorePopUpStore from "../core/core-popup-store";
import { apiCallGetPendingReports } from "../../api/report-api/api-call-get-pending-reports";
import { MINIMUM_REPORTS_BY_TYPE_LIMIT } from "../../constants/input-entries-constants";

export const getPendingReports = async (withURLSearch: boolean) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallGetPendingReports({
    limit: MINIMUM_REPORTS_BY_TYPE_LIMIT,
    createdFromType: getReportsStore().createdFromType.get().value
  });
  if (status === "OK") {
    let databaseReports = reduce(() => data, {});
    const reportedIds = Object.keys(databaseReports);

    if (withURLSearch) {
      const firstReport = databaseReports[reportedIds[0]].data[0];
      const isReportIndonesianMalaysian =
        firstReport.isReportIndonesianMalaysian;
      !isReportIndonesianMalaysian
        ? getReportsStore().setReportCreatedFromType({
            label: "Other",
            value: "Other"
          })
        : getReportsStore().setReportCreatedFromType({
            label: "Indonesia/Malaysia",
            value: "indonesia_malaysia"
          });
    }

    reportedIds.forEach((reportedId) => {
      databaseReports[reportedId].data.map((report) => {
        report.conversation = parseConversationData(report.conversation);
        return report;
      });
    });
    getReportsStore().setPendingReports(databaseReports);
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
  getCoreUIStore().setIsLoading("REPORTS", false);
};
